<template>
  <div id="touristExplain" @scroll="scroll"  style="overflow-x: hidden;box-sizing: border-box;">
    <div style="margin-bottom:20px;font-size: 14px;font-weight: bold">
      购买须知编辑 —— {{title}}
    </div>
    <Evform label-width="100px"
            :model="model"
            :beforSubmit="beforSubmit"
            :urlSubmit="urlSubmit"
            :submitType="submitType"
            :afterSubmit="afterSubmit"
            :btnDoReset="getExplainData"
            :btnShowReset="true"
            :loading="false">
      <template v-for="(item,index) in model.instructList">
        <el-col style="width:80%; margin-bottom:20px"
                :key="index">
          <div class="setting">
            <div class="throughline">
              <div class="el-icon-s-flag firsticon">
                <input v-model="item.name"
                       @blur="blurExp(item)"
                       v-if="item.type1&&item.type1=='add'"
                       placeholder="请输入名称"
                       maxlength="30"
                       type="text">
                <span v-else>{{item.name}}</span>
              </div>
              <span class="icon">
                <i class="el-icon-s-tools bluestyle"
                   @click="iconBtn('setting',item,index)"></i>
                <i class="el-icon-delete-solid bluestyle"
                   @click="iconBtn('del',item,index)"></i>
                <i class="el-icon-bottom "
                   :class="index!=model.instructList.length-1?'bluestyle':'disablestyle'"
                   @click="index!=model.instructList.length-1&&iconBtn('bottom',item,index)"></i>
                <i class="el-icon-top "
                   :class="index!=0?'bluestyle':'disablestyle'"
                   @click="index!=0&&iconBtn('top',item,index)"></i>
                <i class="el-icon-circle-plus bluestyle"
                   @click="iconBtn('add',item,index)"></i>
              </span>
            </div>
          </div>
          <!-- <ClUeditor :UeId="index+1"
                     v-model="item.remark"
                     Url="/api/zuul/wtcp-material/uploads/material">
          </ClUeditor> -->
           <ClUeditor :UeId="index+1" :config={topOffset:110} :material="true"
              v-model="item.remark" :offset="50">
            </ClUeditor>
        </el-col>
      </template>

    </Evform>

    <!--对话框-->
    <el-dialog title="修改项目名称"
               :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="项目名称："
                      :label-width="formLabelWidth">
          <el-input v-model="selectItem.name" maxlength="30"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary"
                   @click="handleAffirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'travelLineExplain',
  data () {
    return {
      pos: 0,
      urlSubmit: "/wtcp-product/scenicTickets/scenic/savePurchaseNotice", //请求地址
      submitType: 'put',
      content: '',
      model: {
        id: 0,
        instructList: null
      },
      title: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      selectItem: { name: '' },//选中的说明数据
      selectIndex: ''//选中的说明数据的下标
    }
  },
  created () {
    this.model.id = this.$route.query.id
    this.title = this.$route.query.title
    // 获取数据详情
    this.getExplainData()
  },
  methods: {
    blurExp (val) {
      if (val.name != '') {
        val.type1 = ''
      }
    },
    //icon  事件
    iconBtn (val, item, index) {
      if (val == 'add') {
        this.selectIndex = index
        let data = {
          type1: 'add',
          id: this.model.instructList.length + 111,
          name: '',
          remark: '',
        }
        this.model.instructList.splice(index + 1, 0, data)
      } else if (val == 'setting') {
        this.selectIndex = index
        this.selectItem = item
        this.dialogFormVisible = true
      } else if (val == 'del') {
        this.$confirm('请问是否执行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.selectIndex = index
          this.selectItem = item
          this.model.instructList.splice(this.selectIndex, 1)
          this.$message({
            type: "success",
            message: "删除成功"
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          });
        });
      } else if (val == 'bottom') {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.selectIndex = index
        this.model.instructList.splice(index + 1, 1, ...this.model.instructList.splice(index, 1, this.model.instructList[index + 1]));
        //滚动条跳转
        let div = document.getElementById('touristExplain');
        div.scrollTop = this.pos+400
      } else if (val == 'top') {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.selectIndex = index
        this.model.instructList.splice(index - 1, 1, ...this.model.instructList.splice(index, 1, this.model.instructList[index - 1]));
        //滚动条跳转
        let div = document.getElementById('touristExplain');
        div.scrollTop = this.pos-400
      }

    },
    //修改名字取消时间
    handleCancel () {
      this.$message({
        type: "info",
        message: "取消操作"
      });
      this.dialogFormVisible = false
    },
    //修改名字确认事件
    handleAffirm () {
      this.model.instructList[this.selectIndex] = this.selectItem
      this.$message({
        type: "success",
        message: "修改成功"
      });
      this.dialogFormVisible = false
    },
    afterSubmit () {
      this.$router.go(-1)
      this.model = {}
    },
    beforSubmit () {
      this.model.instructList.forEach(el => {
        el.fieldName = el.name
        el.content = el.remark
        el.principalId = el.parentId
      });
    },
    // 获取数据详情
    getExplainData () {
      this.request.get('wtcp-product/scenicTickets/scenic/findPurchaseNotice', { id: this.model.id }).then(res => {
        if (res.status === 1) {
          this.request.removeLocal('ueditor_preference')
          this.model.instructList = res.data
        }
      })
    },
    scroll(event) {
       this.pos = event.target.scrollTop
    },
  }

}

</script>

<style scoped>
.icon {
  display: inline-block;
  background: #fff;
  padding: 0 18px;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  margin-left: 60px;
}
.firsticon {
  display: inline-block;
  background: #fff;
  padding: 0 10px;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  margin-left: 20px;
}
.bluestyle {
  color: #02a7f0;
  cursor: pointer;
  padding: 0 5px;
}
.disablestyle {
  cursor: pointer;
  padding: 0 5px;
}
.setting {
  /* background-color: #fff; */
  margin-bottom: 8px;
}
.throughline:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #ccc;
  position: relative;
  top: 10px;
  left: 0;
}
#touristExplain >>> .fn-clear {
  position: absolute;
  right: 45px;
  top: 125px;
  /* width: 80%; */
}
/*#touristExplain >>> .edui-editor-iframeholder {*/
/*  height: 250px !important;*/
/*}*/
</style>